import React from "react";
import PopupScreen from "../../PopupScreen/PopupScreen";

interface CheckoutModalProps {
  modal: boolean;
  cartId: string | null;
  backHome: (data: any) => void;
  onDone: () => void;
}

const CheckoutModal: React.FC<CheckoutModalProps> = ({ modal, cartId, backHome, onDone }) => {
  if (!modal) return null;

  return (
    <div className="modal">
      <div className="overlay">
        <div className="modal-content">
          <PopupScreen cartId={cartId} backHome={backHome} onDone={onDone} />
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
